module.exports = __webpack_public_path__ + "static/media/savio32.72ae1311.jpg";